/**
 * Logging levels.
 *
 * Logging levels conform to the severity ordering specified by RFC5424.
 * These are prioritized from 0 to 7 (highest to lowest).
 *
 *  0 = Emergency: system is unusable
 *  1 = Alert: action must be taken immediately
 *  2 = Critical: critical conditions
 *  3 = Error: error conditions
 *  4 = Warning: warning conditions
 *  5 = Notice: normal but significant condition
 *  6 = Informational: informational messages
 *  7 = Debug: debug-level messages
 *
 * @see https://tools.ietf.org/html/rfc5424
 */
export enum LogLevel {
  EMERG,
  ALERT,
  CRIT,
  ERROR,
  WARN,
  NOTICE,
  INFO,
  DEBUG
}
